import axios from 'axios';

const API_BASE_URL = "https://ims.holdthechild.net/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Inject bearer token from localStorage automatically
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // adjust key if different
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API calls - always return array
export const getProjects = async () => {
  const res = await apiClient.get('/projects');
  return Array.isArray(res.data?.data) ? res.data.data: [];
};

export const getDonors = async () => {
  const res = await apiClient.get('/donors');
  return Array.isArray(res.data) ? res.data : [];
};

export const getProjectStats = async () => {
  const res = await apiClient.get('/projects/stats/summary');
  return res.data?.data ||{}; 
};

export const getDonorStats = async () => {
  const res = await apiClient.get('/donors/stats/summary');
  return res.data.data; };

export const getLeaveRequests = async () => {
  const res = await apiClient.get('/leave-request');
  return Array.isArray(res.data) ? res.data : [];
};


export const getDisciplinaryCases = async () => {
  const res = await apiClient.get('/api/disciplinary-cases');
  return Array.isArray(res.data) ? res.data : [];
};

export const getDisciplinaryStats= async () => {
  const res = await apiClient.get('/disciplinary-cases/stats/summary');
  return res.data
};

export const getDisciplinaryStatsByDepartment = async () => {
  const res = await apiClient.get('/disciplinary-cases/stats/by-department');
return res.data.map(dep => ({
      department: dep.department,
      pending: dep.pending,
      resolved: dep.resolved,
      dismissed: dep.dismissed
    }))
  ;}

  export const getLeaveStats = async () => {  
  const res = await apiClient.get('/leave-request/stats');
  return res.data
};